export default __webpack_public_path__ + "static/media/cxqqreer.ff52b1f4.svg";